export default function hidePhone(phone?: string): string {
  if (!phone) return '';
  return `(••) •••••${phone?.slice(8)}`;
}
